import { Component, Input } from '@angular/core';
import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';

export interface TableColumn {
  key: string;
  label: string;
  type?: 'text' | 'number' | 'currency' | 'percent';
}

@Component({
  selector: 'app-eval-table',
  standalone: true,
  imports: [MatTableModule, CurrencyPipe, DecimalPipe, PercentPipe],
  templateUrl: './evaluations-table.component.html',
  styleUrl: './evaluations-table.component.scss',
})

export class EvaluationsTableComponent {
  @Input() data: any[] = [];
  @Input() columns: TableColumn[] = [];
  @Input() sumRow: { label: string; values: Partial<Record<string, number>> } | null = null;

  get columnKeys(): string[] {
    return this.columns.map(c => c.key);
  }
}
